import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommonSelectListService } from '../../../shared/service/common-select-list.service';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { SystemConfigService } from '../../../system-config/service/system-config.service';
import { PartyModal } from '../modal/party-modal';
import { PartyDetailsBranchModel } from '../modal/party-details-branch-model';
import { BranchModel } from '../../branch/model/branch-model';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { Puritymodal } from '../../purity/modal/puritymodal';
import { PartyModuleParamConfigModel } from '../modal/party-module-param-config-model';

@Component({
  selector: 'app-branch-location',
  templateUrl: './branch-location.component.html',
  styleUrls: ['./branch-location.component.css'],
})
export class BranchLocationComponent extends AbstractBaseDetailsComponent implements OnInit, OnChanges {
  @Input() partyId: number;
  @Input() mainData: PartyModal;
  branchFormGroup: FormGroup;

  @Output('addCallback') addCallBack: EventEmitter<void> = new EventEmitter<void>();

  branchList: Array<BranchModel>;
  @Input() isUpdateComponent: boolean;
  private branchMap: Map<number, BranchModel>;
  filterBranch: Array<BranchModel>;
  moduleParam: PartyModuleParamConfigModel = new PartyModuleParamConfigModel(this.moduleParamConfigGlobService);

  constructor(
    public toaster: ToastrService,
    private formBuilder: FormBuilder,
    private commonService: CommonSelectListService,
    private moduleParamConfigGlobService: ModuleParamGlobConfigService,
    private systemConfigService: SystemConfigService
  ) {
    super(toaster);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (changes.mainData) {
      if (changes.mainData.currentValue) {
        if (this.mainData && this.mainData.branchDetails && this.mainData.branchDetails.length !== 0) {
          console.log(this.mainData.branchDetails);
          this.onUpdateValidation();
        }
      }
    }
  }

  ngOnInit() {
    this.setData();
    this.setValidation();
    this.getBranchList(true);
  }

  setData() {
    if (!this.isUpdateComponent) {
      this.mainData = new PartyModal();
      if ((this.mainData && !this.mainData.branchDetails) || this.mainData.branchDetails.length == 0) {
        this.mainData.branchDetails = new Array<PartyDetailsBranchModel>();
      }
    }
  }

  setValidation() {
    this.branchFormGroup = this.formBuilder.group({
      branchDetails: this.formBuilder.array([this.createBranchControls()]),
    });
  }

  onUpdateValidation() {
    if (this.mainData.branchDetails && this.mainData.branchDetails.length !== 0) {
      let branchControl = this.branchFormGroup.get('branchDetails') as FormArray;
      for (let i = 1; i < this.mainData.branchDetails.length; i++) {
        branchControl.push(this.createBranchControls());
      }
    }
  }

  createBranchControls(): FormGroup {
    return this.formBuilder.group({
      branch: [{ value: '', disabled: false }, Validators.required],
      isDefaultBranch: [],
    });
  }

  onUpdateCreateBranchControls(): FormGroup {
    return this.formBuilder.group({
      branch: ['', Validators.required],
      isDefaultBranch: [],
    });
  }

  er(i: number) {
    return (<FormArray>this.branchFormGroup.get('branchDetails')).at(i);
  }

  getBranchList(refresh: boolean) {
    if (!this.branchList || this.branchList.length == 0 || refresh) {
      this.commonService.getBranchList().subscribe((response) => {
        this.validateResponse(response, () => {
          this.branchList = new Array<BranchModel>();
          this.branchList = response.dataList;
          this.filterBranch = JSON.parse(JSON.stringify(response.dataList));
          this.filterBranchList();
        });
      });
    }
  }

  filterBranchList() {
    this.branchMap = new Map<number, BranchModel>();
    this.branchList = this.filterBranch;
    if (this.mainData.branchDetails && this.mainData.branchDetails.length !== 0) {
      this.mainData.branchDetails.forEach((ls) => {
        const id = ls.branch && ls.branch.id ? ls.branch.id : 0;
        if (id > 0) {
          if (!this.branchMap.has(id)) {
            this.branchMap.set(ls.branch.id, ls.branch);
          }
        }
      });
    }
    this.branchList = this.branchList.filter((ls) => {
      if (!ls.party) return true;
      if (ls.party && ls.party == this.mainData.id) return true;
    });
    this.branchList = this.branchList.filter((list) => {
      return !this.branchMap.has(list.id);
    });
  }

  onBranchDefault(i: number, event: { previousValue: boolean; currentValue: boolean }) {
    this.mainData.branchDetails[i].isDefaultBranch = false;
    const defaultBranch = this.mainData.branchDetails.find((def) => def.isDefaultBranch);
    if (event.currentValue) {
      if (defaultBranch) {
        const confirmIS = confirm('Are sure want to override Default Branch?');
        if (confirmIS) {
          this.mainData.branchDetails[i].isDefaultBranch = true;
          let previousDefaultBranch = this.mainData.branchDetails.indexOf(defaultBranch);
          this.mainData.branchDetails[previousDefaultBranch].isDefaultBranch = false;
          return;
        }
        event.currentValue = !event.currentValue;
        event.previousValue = !event.previousValue;
        return;
      }
      this.mainData.branchDetails[i].isDefaultBranch = true;
    }
  }

  onBranchDelete(i: number) {
    if (confirm('Are sure want to Delete?')) {
      const branchControl = this.branchFormGroup.controls.branchDetails as FormArray;
      branchControl.removeAt(i);
      if (this.mainData.branchDetails[i].branch && this.branchMap.has(this.mainData.branchDetails[i].branch.id))
        this.branchMap.delete(this.mainData.branchDetails[i].branch.id);

      this.mainData.branchDetails.splice(i, 1);
      this.checkDefault();
      this.filterBranchList();
    }
  }

  checkDefault() {
    if (this.mainData.branchDetails.length == 1) {
      this.mainData.branchDetails[0].isDefaultBranch = true;
    }
  }

  onAddBranch() {
    if (!this.mainData.branchDetails || this.mainData.branchDetails.length === 0) {
      this.mainData.branchDetails = new Array<PartyDetailsBranchModel>();
    }
    if (this.branchFormGroup.invalid) {
      if (!this.mainData.branchDetails || this.mainData.branchDetails.length === 0) {
        this.mainData.branchDetails = new Array<PartyDetailsBranchModel>();
        let obj = new PartyDetailsBranchModel();
        obj.isDefaultBranch = false;
        this.mainData.branchDetails.push(obj);
        if (this.mainData.branchDetails.length === 1) {
          this.mainData.branchDetails[0].isDefaultBranch = true;
        }
        return;
      }
      this.toaster.warning('Please add Details!!', 'WARNING');
      return;
    }
    let obj = new PartyDetailsBranchModel();
    obj.isDefaultBranch = false;
    this.mainData.branchDetails.push(obj);
    if (this.mainData.branchDetails.length === 1) {
      this.mainData.branchDetails[0].isDefaultBranch = true;
    }
    this.createBranchValidation();
    this.filterBranchList();
  }

  private createBranchValidation() {
    let branchControl = this.branchFormGroup.get('branchDetails') as FormArray;
    branchControl.push(this.onUpdateCreateBranchControls());
  }
}
